import { render, staticRenderFns } from "./ModalRemoveCloudflare.vue?vue&type=template&id=3317e7b1"
import script from "./ModalRemoveCloudflare.vue?vue&type=script&lang=js"
export * from "./ModalRemoveCloudflare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports